var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImportantBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_260_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.4375 11.495C37.7208 12.2247 38.5092 13.5905 38.5 15.0663V28.4203C38.5 29.9035 37.6878 31.2712 36.377 31.9917L24.002 39.82C23.3885 40.1568 22.6999 40.3334 22 40.3334C21.3001 40.3334 20.6115 40.1568 19.998 39.82L7.623 31.9917C6.98164 31.6412 6.44623 31.1248 6.07275 30.4965C5.69928 29.8683 5.50147 29.1512 5.5 28.4203V15.0645C5.5 13.5813 6.31217 12.2155 7.623 11.495L19.998 4.19833C20.6296 3.85007 21.3392 3.66742 22.0605 3.66742C22.7818 3.66742 23.4914 3.85007 24.123 4.19833L36.498 11.495H36.4375Z",
    stroke: "#00ABFB",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 29.3333V29.3517",
    stroke: "#00ABFB",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 23.8333C22.8245 23.8358 23.6259 23.5603 24.2745 23.0513C24.9232 22.5423 25.3814 21.8295 25.5751 21.028C25.7688 20.2265 25.6867 19.3832 25.342 18.6341C24.9974 17.885 24.4103 17.274 23.6757 16.8997C22.9463 16.526 22.112 16.4102 21.3085 16.571C20.5049 16.7318 19.7794 17.1597 19.25 17.7852",
    stroke: "#00ABFB",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_260_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImportantBlue);
export default __webpack_public_path__ + "static/media/Icon_Important_Blue.f606fb85c7194c0c51edef074e117314.svg";
export { ForwardRef as ReactComponent };